module.exports = __webpack_public_path__ + "static/img/Front.0bc6a5d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/Front.svg
// module id = KgAb
// module chunks = 1